// One place for the brand wording shared by the topbar and the login screen —
// mirrors avakaayafoods.com's header so Nexus reads as the same company.
export const BRAND = {
  name: 'Avakaaya Foods',
  system: 'Nexus',                                          // the internal system's name
  systemName: 'Avakaaya Nexus',                             // how it is introduced in full
  tagline: ['Authentic Telugu Pickles', 'Sweets', 'Snacks'], // joined with a gold dot
  since: 'Since 2000',
  logo: '/avakaaya-logo.png',
};
